var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.storification || _vm.story
    ? _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.deselectDragObjects,
              expression: "deselectDragObjects",
            },
          ],
          ref: "screen-instagram",
          staticClass: "vs-con-loading__container",
          class: _vm.story && _vm.story.isReel && "screen-reel",
          attrs: { id: "screen-instagram" },
          on: { mousedown: _vm.deselectDragObjects },
        },
        [
          _vm.isDragging
            ? _c("div", {
                ref: "widgetCenterVertical",
                staticClass: "centered-line-vertical",
                attrs: { hidden: "", "data-html2canvas-ignore": "" },
              })
            : _vm._e(),
          _vm.isDragging
            ? _c("div", {
                ref: "widgetCenterHorizontal",
                staticClass: "centered-line-horizontal",
                attrs: { hidden: "", "data-html2canvas-ignore": "" },
              })
            : _vm._e(),
          _vm.isRotate
            ? _c("div", {
                ref: "widgetRotate",
                staticClass: "rotate-line",
                attrs: { hidden: "", "data-html2canvas-ignore": "" },
              })
            : _vm._e(),
          _vm.storification
            ? _c(
                "div",
                {
                  staticClass: "storification",
                  style: {
                    backgroundColor: _vm.screenshotPuppeteer
                      ? "transparent"
                      : _vm.backgroundColor,
                  },
                },
                [
                  _vm.storification.video
                    ? _c("video", {
                        ref: "main-img",
                        staticClass: "share-video",
                        style: { opacity: _vm.screenshotPuppeteer ? 0 : 1 },
                        attrs: {
                          muted: "",
                          poster: _vm.storification.image,
                          src: _vm.storification.video,
                          autoplay: "",
                          loop: "",
                        },
                        domProps: { muted: true },
                        on: { loadeddata: (e) => _vm.loadVideo(e, true) },
                      })
                    : _vm.storification.image
                    ? _c("img", {
                        ref: "main-img",
                        staticClass: "share-img",
                        style: { opacity: _vm.screenshotPuppeteer ? 0 : 1 },
                        attrs: { src: _vm.storification.image },
                        on: {
                          load: (e) => _vm.loadImage(e, true),
                          error: _vm.loadImageError,
                        },
                      })
                    : _vm._e(),
                  _vm.storification.image || _vm.storification.video
                    ? _c("p", { staticClass: "share-username" }, [
                        _vm._v("@" + _vm._s(_vm.storification.username)),
                      ])
                    : _vm._e(),
                  _c("img", {
                    staticClass: "carousel-storification",
                    attrs: {
                      hidden: !_vm.storification.isCarousel,
                      src: require("../../assets/img/carousel.svg"),
                    },
                  }),
                  _vm.storification.video
                    ? _c("img", {
                        staticClass: "reel-storification-icon",
                        attrs: {
                          src: require("../../assets/img/icon_instagram_reel.svg"),
                        },
                      })
                    : _vm._e(),
                  _vm.storification.video
                    ? _c(
                        "p",
                        {
                          staticClass: "video-time",
                          attrs: {
                            hidden: {
                              screenshotPuppeteer: _vm.screenshotPuppeteer,
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.currentStorificationVideoTime))]
                      )
                    : _vm._e(),
                  _vm.currentMod === _vm.Mods.DEFAULT &&
                  !_vm.screenshotPuppeteer
                    ? _c(
                        "div",
                        {
                          staticClass: "icons-bar",
                          attrs: { "data-html2canvas-ignore": "" },
                        },
                        [
                          !_vm.preview
                            ? _c("div", {
                                staticClass: "add-text-icon icons",
                                attrs: { "data-no-deselect": "" },
                                on: {
                                  click: function ($event) {
                                    _vm.$store.dispatch(
                                      "addStorificationTextDefault",
                                      ""
                                    )
                                    _vm.setMod(_vm.Mods.TEXT)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm.storification.widgetsReel && !_vm.screenshotPuppeteer
                    ? _c(
                        "div",
                        { staticClass: "widget-reels-storification" },
                        [
                          _vm.storification.widgetsReel.texts &&
                          _vm.storification.widgetsReel.texts.length
                            ? _c(
                                "div",
                                { staticClass: "texts-container-view" },
                                _vm._l(
                                  _vm.storification.widgetsReel.texts,
                                  function (text, idx) {
                                    return _c(
                                      "div",
                                      {
                                        key: `textReel-${idx}`,
                                        ref: `textReel-${idx}`,
                                        refInFor: true,
                                        staticClass: "textReel",
                                        class: `font${text.font} ${
                                          !text.visible && "text-hide"
                                        }`,
                                        style: "border: none;",
                                        attrs: {
                                          "data-no-deselect": "",
                                          "data-name": "TextReel",
                                          "data-index": idx,
                                          "data-init":
                                            text && JSON.stringify(text),
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "text-visualization" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.textsReelComputed[idx])
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _vm._e(),
                          _vm._l(
                            _vm.storification.widgetsReel.gifs,
                            function (gif, idx) {
                              return _c(
                                "div",
                                {
                                  key: `gif-${idx}`,
                                  staticClass: "gif",
                                  style: {
                                    maxWidth: _vm.screenSize.width + "px",
                                    border: "none",
                                  },
                                  attrs: {
                                    "data-name": "GifReel",
                                    "data-index": idx,
                                    "data-init": gif && JSON.stringify(gif),
                                  },
                                },
                                [
                                  _c("img", {
                                    style: {
                                      maxWidth:
                                        _vm.screenSize.width * 0.64722222222 +
                                        "px",
                                    },
                                    attrs: {
                                      "data-no-deselect": "",
                                      src: gif.images.preview_gif.url,
                                    },
                                  }),
                                ]
                              )
                            }
                          ),
                          _vm.storification.widgetsReel.music
                            ? _c(
                                "div",
                                {
                                  staticClass: "music-container-view",
                                  attrs: { "data-name": "MusicReel" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "music-preview",
                                      style: `bottom: 10px; left: 10px; top: unset;`,
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: "https://media.giphy.com/media/0mKYWcPUzB0Jp4qXsh/giphy.gif",
                                        },
                                      }),
                                      _c("p", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.musicReelPreview[0])
                                          ),
                                        ]),
                                        _vm._v(
                                          " . " +
                                            _vm._s(_vm.musicReelPreview[1]) +
                                            " ›"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              )
            : _vm.story
            ? _c(
                "div",
                {
                  staticClass: "story",
                  style: {
                    backgroundColor: _vm.screenshotPuppeteer
                      ? "transparent"
                      : _vm.story.video &&
                        _vm.story.isReel &&
                        _vm.story.enclosure
                      ? "white"
                      : _vm.backgroundColor,
                  },
                },
                [
                  _vm.story.video && !_vm.screenshotPuppeteer
                    ? _c("video", {
                        ref: "main-img",
                        staticClass: "story-image",
                        attrs: {
                          src: _vm.story.video,
                          playsinline: "",
                          loop: "",
                          poster:
                            _vm.story.isReel && _vm.story.enclosure
                              ? _vm.story.enclosure
                              : null,
                        },
                        domProps: { muted: _vm.music ? true : false },
                        on: {
                          click: (e) =>
                            e.target.paused
                              ? e.target.play()
                              : e.target.pause(),
                        },
                      })
                    : _vm.story.image && !_vm.screenshotPuppeteer
                    ? _c("img", {
                        ref: "main-img",
                        staticClass: "story-image",
                        attrs: { src: _vm.story.image },
                        on: { load: _vm.loadImage },
                      })
                    : _vm._e(),
                  _vm.currentMod === _vm.Mods.DEFAULT &&
                  !_vm.screenshotPuppeteer
                    ? _c(
                        "div",
                        {
                          staticClass: "icons-bar",
                          attrs: { "data-html2canvas-ignore": "" },
                        },
                        [
                          !_vm.story.isReel && !_vm.preview
                            ? _c("div", {
                                staticClass: "remove-img icons",
                                on: {
                                  click: function ($event) {
                                    return _vm.setMod(_vm.Mods.RESET)
                                  },
                                },
                              })
                            : _vm.story.isReel
                            ? _c("div", { staticClass: "reel-name" }, [
                                _vm._v("Reels"),
                              ])
                            : _vm._e(),
                          !_vm.preview
                            ? _c("div", [
                                _vm.story.image
                                  ? _c("img", {
                                      staticClass: "crop-img",
                                      attrs: {
                                        src: require("../../assets/img/icon_instagram_pencil.svg"),
                                        alt: "Crop",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setMod(_vm.Mods.CROPPING)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          !_vm.preview
                            ? _c("div", {
                                staticClass: "add-text-icon icons",
                                attrs: { "data-no-deselect": "" },
                                on: {
                                  click: function ($event) {
                                    _vm.story && _vm.story.isReel
                                      ? _vm.$store.dispatch(
                                          "addStorificationTextDefaultReel",
                                          ""
                                        )
                                      : _vm.$store.dispatch(
                                          "addStorificationTextDefault",
                                          ""
                                        )
                                    _vm.setMod(_vm.Mods.TEXT)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm.currentMod === _vm.Mods.RESET
                    ? _c(
                        "div",
                        {
                          staticClass: "popup-remove-img",
                          attrs: { "data-html2canvas-ignore": "" },
                        },
                        [
                          _vm._m(0),
                          _c("div", { staticClass: "btn-remove-img" }, [
                            _c(
                              "button",
                              {
                                staticClass: "cancel-remove-img",
                                attrs: { tabindex: "0" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.setMod(_vm.Mods.DEFAULT)
                                  },
                                },
                              },
                              [_vm._v("Conserver")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "confirm-remove-img",
                                attrs: { tabindex: "0" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.$store.dispatch("resetStorification")
                                    _vm.$store.dispatch("emitData", {
                                      message: "resetStory",
                                    })
                                    _vm.setMod(_vm.Mods.DEFAULT)
                                  },
                                },
                              },
                              [_vm._v("Abandonner")]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.currentMod === _vm.Mods.CROPPING
                    ? _c(
                        "div",
                        {
                          staticClass: "crop-mod",
                          attrs: { "data-html2canvas-ignore": "" },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "crop-btns crop-cancel",
                              on: {
                                click: function ($event) {
                                  return _vm.setMod(_vm.Mods.DEFAULT)
                                },
                              },
                            },
                            [_vm._v("Annuler")]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "crop-btns crop-confirm",
                              on: {
                                click: function ($event) {
                                  return _vm.confirmCrop()
                                },
                              },
                            },
                            [_vm._v("Sauvegarder")]
                          ),
                          _c("div", { staticClass: "crop-slider-size" }, [
                            _c("img", {
                              staticClass: "crop-size",
                              attrs: {
                                src: require("../../assets/img/icon_instagram_loupe_plus.svg"),
                                alt: "+",
                              },
                            }),
                            _c("input", {
                              staticClass: "crop-slider",
                              attrs: {
                                "data-old-value": "1",
                                type: "range",
                                value: "1",
                                step: "0.05",
                                min: "0",
                                max: "2",
                                dir: "rtl",
                              },
                              on: { input: _vm.cropperZoom },
                            }),
                            _c("img", {
                              staticClass: "crop-size",
                              attrs: {
                                src: require("../../assets/img/icon_instagram_loupe_moins.svg"),
                                alt: "-",
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "crop-actions" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/img/icon_instagram_rotate.svg"),
                                alt: "rotate +",
                              },
                              on: { click: () => _vm.cropper.rotate(45) },
                            }),
                            _c("img", {
                              attrs: {
                                src: require("../../assets/img/icon_instagram_rotate_neg.svg"),
                                alt: "rotate -",
                              },
                              on: { click: () => _vm.cropper.rotate(-45) },
                            }),
                            _c("img", {
                              attrs: {
                                src: require("../../assets/img/icon_instagram_inverse_x.svg"),
                                alt: "inverse x",
                              },
                              on: {
                                click: () =>
                                  _vm.cropper.scaleX(
                                    _vm.cropper.getImageData().scaleX * -1
                                  ),
                              },
                            }),
                            _c("img", {
                              attrs: {
                                src: require("../../assets/img/icon_instagram_inverse_y.svg"),
                                alt: "inverse y",
                              },
                              on: {
                                click: () =>
                                  _vm.cropper.scaleY(
                                    _vm.cropper.getImageData().scaleY * -1
                                  ),
                              },
                            }),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.texts && _vm.texts.length
            ? _c(
                "div",
                {
                  staticClass: "texts-container-view",
                  style:
                    _vm.currentMod === _vm.Mods.CROPPING && "display: none;",
                },
                [
                  _vm._l(_vm.texts, function (text, idx) {
                    return _c(
                      "div",
                      {
                        key: `text-${idx}`,
                        ref: `text-${idx}`,
                        refInFor: true,
                        staticClass: "text",
                        class: `interactable-${_vm._uid} draggable-${
                          _vm._uid
                        } clickable-${_vm._uid} font${text.font} ${
                          !text.visible && "text-hide"
                        }`,
                        style:
                          text.background == 0 &&
                          text.content.trim() !== "" &&
                          _vm.currentMod === _vm.Mods.TEXT &&
                          _vm.selectedObject === idx
                            ? "border: rgba(255, 255, 255, 0.3) solid 1px; border-radius: 0;" +
                              `text-align: ${text.justification || "center"};`
                            : "border: none; " + text.minWidth &&
                              `min-width: ${
                                !(
                                  _vm.currentMod === _vm.Mods.TEXT &&
                                  _vm.selectedObject === idx
                                )
                                  ? text.minWidth + 20
                                  : 0
                              }px; text-align: ${
                                text.justification || "center"
                              };`,
                        attrs: {
                          "data-no-deselect": "",
                          "data-name": "Text",
                          "data-index": idx,
                          "data-init": text && JSON.stringify(text),
                        },
                        on: {
                          clickableCustomFuntion: () => {
                            _vm.selectedObject = idx
                            _vm.setMod(_vm.Mods.TEXT)
                          },
                        },
                      },
                      [
                        _vm.currentMod === _vm.Mods.TEXT &&
                        _vm.selectedObject === idx
                          ? _c("contenteditable", {
                              attrs: {
                                "data-no-deselect": "",
                                tag: "span",
                                contenteditable: true,
                                noNL: false,
                                noHTML: true,
                              },
                              on: { keydown: (e) => _vm.minWidthText(e, idx) },
                              model: {
                                value: text.content,
                                callback: function ($$v) {
                                  _vm.$set(text, "content", $$v)
                                },
                                expression: "text.content",
                              },
                            })
                          : _c("span", { staticClass: "text-visualization" }, [
                              _vm._v(_vm._s(_vm.textsComputed[idx])),
                            ]),
                        _c("img", {
                          staticClass: "rotation-icon no-hover",
                          class: `rotation-${_vm._uid}`,
                          attrs: {
                            "data-no-deselect": "",
                            hidden: !(
                              _vm.currentMod === _vm.Mods.TEXT &&
                              _vm.selectedObject === idx
                            ),
                            src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm.currentMod === _vm.Mods.TEXT
                    ? _c(
                        "div",
                        {
                          staticClass: "text-mod",
                          attrs: { "data-html2canvas-ignore": "" },
                          on: { mouseup: () => _vm.setTextFocus() },
                        },
                        [
                          _c("div", { staticClass: "text-actions" }, [
                            _c("img", {
                              staticClass: "text-justify",
                              attrs: {
                                "data-no-deselect": "",
                                src: require(`../../assets/img/icon_instagram_justify_${_vm.textJustification}.png`),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.textJustify()
                                },
                              },
                            }),
                            _c("img", {
                              staticClass: "text-color-view",
                              attrs: {
                                "data-no-deselect": "",
                                src: require("../../assets/img/icon_instagram_color.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.textColorView = !_vm.textColorView
                                },
                              },
                            }),
                            _c("img", {
                              staticClass: "text-background",
                              attrs: {
                                "data-no-deselect": "",
                                "data-value": "0",
                                src: require(`../../assets/img/icon_instagram_fond${
                                  _vm.texts[_vm.selectedObject].background === 0
                                    ? 1
                                    : 2
                                }.png`),
                              },
                              on: {
                                click: (e) =>
                                  _vm.textSpecialsModifications(
                                    _vm.selectedObject,
                                    {
                                      background:
                                        (_vm.texts[_vm.selectedObject]
                                          .background +
                                          1) %
                                        (_vm.texts[_vm.selectedObject].font ===
                                        3
                                          ? 2
                                          : 3),
                                    }
                                  ),
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "text-end",
                                attrs: { "data-no-deselect": "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setMod(_vm.Mods.DEFAULT)
                                  },
                                },
                              },
                              [_vm._v("Terminer")]
                            ),
                          ]),
                          _c("div", { staticClass: "text-slider-size" }, [
                            _c("img", {
                              staticClass: "text-size",
                              attrs: {
                                "data-no-deselect": "",
                                src: require("../../assets/img/icon_instagram_txt_plus.png"),
                                alt: "+",
                              },
                            }),
                            _c("input", {
                              staticClass: "text-slider",
                              attrs: {
                                "data-no-deselect": "",
                                type: "range",
                                step: "1",
                                min: "15",
                                max: "75",
                                dir: "rtl",
                              },
                              domProps: {
                                value: _vm.texts[_vm.selectedObject].size,
                              },
                              on: {
                                input: (e) =>
                                  _vm.textSpecialsModifications(
                                    _vm.selectedObject,
                                    { size: e.target.value }
                                  ),
                              },
                            }),
                            _c("img", {
                              staticClass: "text-size",
                              attrs: {
                                "data-no-deselect": "",
                                src: require("../../assets/img/icon_instagram_txt_moins.png"),
                                alt: "-",
                              },
                            }),
                          ]),
                          _vm.textColorView
                            ? _c(
                                "div",
                                { staticClass: "text-colors" },
                                _vm._l(_vm.textColors, function (color) {
                                  return _c("div", {
                                    key: color,
                                    staticClass: "color",
                                    style: {
                                      backgroundColor: color,
                                      borderColor:
                                        color === "white" ? "black" : "white",
                                    },
                                    attrs: { "data-no-deselect": "" },
                                    on: {
                                      click: () =>
                                        _vm.textSpecialsModifications(
                                          _vm.selectedObject,
                                          { color }
                                        ),
                                    },
                                  })
                                }),
                                0
                              )
                            : _vm._e(),
                          !_vm.isDragging
                            ? _c(
                                "div",
                                { staticClass: "text-fonts" },
                                [
                                  _vm._l(4, function (idx) {
                                    return _c(
                                      "span",
                                      {
                                        key: idx,
                                        class: `font${idx} font`,
                                        style:
                                          _vm.texts[_vm.selectedObject].font ===
                                          idx
                                            ? "background-color: white; color: #ba3420;"
                                            : "background-color: #26262670; color: white;",
                                        attrs: { "data-no-deselect": "" },
                                        on: {
                                          click: () =>
                                            _vm.textSpecialsModifications(
                                              _vm.selectedObject,
                                              { font: idx }
                                            ),
                                        },
                                      },
                                      [_vm._v("Aa")]
                                    )
                                  }),
                                  _c(
                                    "span",
                                    {
                                      key: 10,
                                      class: `font${10} font`,
                                      style:
                                        _vm.texts[_vm.selectedObject].font ===
                                        10
                                          ? "background-color: white; color: #ba3420;"
                                          : "background-color: #26262670; color: white;",
                                      attrs: { "data-no-deselect": "" },
                                      on: {
                                        click: () =>
                                          _vm.textSpecialsModifications(
                                            _vm.selectedObject,
                                            { font: 10 }
                                          ),
                                      },
                                    },
                                    [_vm._v("Aa")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      key: 11,
                                      class: `font${11} font`,
                                      style:
                                        _vm.texts[_vm.selectedObject].font ===
                                        11
                                          ? "background-color: white; color: #ba3420;"
                                          : "background-color: #26262670; color: white;",
                                      attrs: { "data-no-deselect": "" },
                                      on: {
                                        click: () =>
                                          _vm.textSpecialsModifications(
                                            _vm.selectedObject,
                                            { font: 11 }
                                          ),
                                      },
                                    },
                                    [_vm._v("Aa")]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm.link && _vm.link.url && _vm.link.isActive
            ? _c(
                "div",
                {
                  class: `interactable-${_vm._uid} draggable-${_vm._uid} resizable-${_vm._uid} colorable-${_vm._uid} link-container-view style-color-0`,
                  style:
                    _vm.currentMod === _vm.Mods.CROPPING && "display: none;",
                  attrs: {
                    "data-name": "Link",
                    "data-init":
                      _vm.link.initialDatas &&
                      JSON.stringify(_vm.link.initialDatas),
                    "data-number-style-color": "4",
                  },
                },
                [
                  _c("img", {
                    staticClass: "link-img",
                    attrs: {
                      src: require("../../assets/img/icon_instagram_link.svg"),
                      alt: "Link",
                    },
                  }),
                  _c("p", { staticClass: "link-txt" }, [
                    _vm._v(
                      _vm._s(
                        _vm.link.text
                          ? _vm.link.text.toUpperCase()
                          : _vm.link.url
                              .split("/")[2]
                              .toUpperCase()
                              .split("?")[0]
                              .replace("WWW.", "")
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "corner edge-top edge-left" }),
                  _c("div", { staticClass: "corner edge-top edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-left" }),
                  _c("img", {
                    staticClass: "rotation-icon",
                    class: `rotation-${_vm._uid}`,
                    attrs: {
                      hidden: !!_vm.preview,
                      "data-no-deselect": "",
                      src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm._l(_vm.layers, function (layer, idx) {
            return _c(
              "div",
              {
                key: `layer-${idx}`,
                staticClass: "layer",
                class: `interactable-${_vm._uid} draggable-${_vm._uid} resizable-${_vm._uid}`,
                style: {
                  maxWidth: _vm.screenSize.width + "px",
                  maxHeight: _vm.screenSize.height + "px",
                  display:
                    _vm.currentMod === _vm.Mods.CROPPING ? "none" : "block",
                },
                attrs: {
                  "data-name": "Layer",
                  "data-index": idx,
                  "data-init": layer && JSON.stringify(layer),
                },
              },
              [
                _c("img", {
                  style: { maxWidth: _vm.screenSize.width + "px" },
                  attrs: { src: layer.reader || layer.url },
                }),
                _c("div", { staticClass: "corner edge-top edge-left" }),
                _c("div", { staticClass: "corner edge-top edge-right" }),
                _c("div", { staticClass: "corner edge-bottom edge-right" }),
                _c("div", { staticClass: "corner edge-bottom edge-left" }),
              ]
            )
          }),
          _vm._l(_vm.gifs, function (gif, idx) {
            return _c(
              "div",
              {
                key: `gif-${idx}`,
                staticClass: "gif",
                class: `interactable-${_vm._uid} draggable-${_vm._uid} resizable-${_vm._uid}`,
                style: {
                  maxWidth: _vm.screenSize.width + "px",
                  border:
                    `gif_${gif.id}` === _vm.selectedObject
                      ? "2px solid rgb(222, 6, 136)"
                      : "none",
                  display:
                    _vm.currentMod === _vm.Mods.CROPPING ||
                    _vm.screenshotPuppeteer
                      ? "none"
                      : "",
                },
                attrs: {
                  "data-name": "Gif",
                  "data-index": idx,
                  "data-init": gif && JSON.stringify(gif),
                },
                on: {
                  mousedown: function ($event) {
                    _vm.selectedObject = "gif_" + gif.id
                  },
                },
              },
              [
                _c("img", {
                  style: { maxWidth: _vm.screenSize.width + "px" },
                  attrs: {
                    "data-no-deselect": "",
                    src: gif.images.preview_gif.url,
                  },
                }),
                _c("div", {
                  staticClass: "corner edge-top edge-left",
                  attrs: { "data-no-deselect": "" },
                }),
                _c("div", {
                  staticClass: "corner edge-top edge-right",
                  attrs: { "data-no-deselect": "" },
                }),
                _c("div", {
                  staticClass: "corner edge-bottom edge-right",
                  attrs: { "data-no-deselect": "" },
                }),
                _c("div", {
                  staticClass: "corner edge-bottom edge-left",
                  attrs: { "data-no-deselect": "" },
                }),
                _c("img", {
                  staticClass: "rotation-icon no-hover",
                  class: `rotation-${_vm._uid}`,
                  attrs: {
                    hidden: `gif_${gif.id}` !== _vm.selectedObject,
                    "data-no-deselect": "",
                    src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                  },
                }),
              ]
            )
          }),
          _vm.music && !_vm.screenshotPuppeteer
            ? _c(
                "div",
                {
                  staticClass: "music-container-view",
                  style:
                    _vm.currentMod === _vm.Mods.CROPPING && "display: none;",
                  attrs: { "data-name": "Music" },
                },
                [
                  _c("audio", {
                    ref: "music-story-player",
                    attrs: {
                      src: _vm.music.track.fast_start_progressive_download_url,
                    },
                    on: {
                      canplaythrough: (e) => (e.target.volume = "0.5"),
                      timeupdate: (e) => {
                        if (_vm.$refs["music-percent"])
                          _vm.$refs["music-percent"].style.width = `${
                            (100 *
                              (e.target.currentTime * 1000 - _vm.music.start)) /
                            (_vm.music.end - _vm.music.start)
                          }%`
                        if (e.target.currentTime * 1000 > _vm.music.end)
                          e.target.currentTime = _vm.music.start / 1000
                      },
                    },
                  }),
                  _vm.music.config && !_vm.preview
                    ? _c(
                        "div",
                        { staticClass: "music-config" },
                        [
                          !_vm.isVideo
                            ? _c(
                                "select",
                                {
                                  staticClass: "timer-music",
                                  on: {
                                    focus: function ($event) {
                                      _vm.story && _vm.story.isReel
                                        ? _vm.$store.commit(
                                            "updateStorificationMusicReel",
                                            { paused: true }
                                          )
                                        : _vm.$store.commit(
                                            "updateStorificationMusic",
                                            { paused: true }
                                          )
                                    },
                                    change: (e) =>
                                      _vm.story.isReel
                                        ? _vm.$store.commit(
                                            "updateStorificationMusicReel",
                                            {
                                              duration:
                                                parseInt(e.target.value) * 1000,
                                            }
                                          )
                                        : _vm.$store.commit(
                                            "updateStorificationMusic",
                                            {
                                              duration:
                                                parseInt(e.target.value) * 1000,
                                            }
                                          ),
                                  },
                                },
                                _vm._l(
                                  [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                                  function (k) {
                                    return _c(
                                      "option",
                                      {
                                        key: k,
                                        domProps: {
                                          selected:
                                            k === _vm.music.duration / 1000,
                                          value: k,
                                        },
                                      },
                                      [_vm._v(_vm._s(k))]
                                    )
                                  }
                                ),
                                0
                              )
                            : _c(
                                "select",
                                {
                                  staticClass: "timer-music",
                                  attrs: { disabled: "" },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: _vm.music.duration / 1000,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          Math.round(_vm.music.duration / 1000)
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                          _c("vue-slider", {
                            staticClass: "slider",
                            attrs: {
                              value: [_vm.music.start, _vm.music.end],
                              dotSize: "10",
                              fixed: true,
                              min: 0,
                              max: _vm.music.track.duration_in_ms,
                              "tooltip-formatter": (ms) =>
                                `${Math.floor(ms / 60000)}:${String(
                                  Math.round((ms % 60000) / 1000)
                                ).padStart(2, "0")}`,
                              marks:
                                _vm.music.track.highlight_start_times_in_ms,
                              "hide-label": true,
                              dotStyle: { visibility: "hidden", width: "50px" },
                              processStyle: {
                                backgroundColor: "white",
                                zIndex: 1000,
                              },
                              railStyle: {
                                backgroundColor: "rgb(94,86,83)",
                                height: "inherit",
                              },
                            },
                            on: {
                              "drag-end": () => {},
                              "drag-start": () => {},
                              change: ([start, end]) =>
                                _vm.story.isReel
                                  ? _vm.$store.commit(
                                      "updateStorificationMusicReel",
                                      { start }
                                    )
                                  : _vm.$store.commit(
                                      "updateStorificationMusic",
                                      { start }
                                    ),
                            },
                          }),
                          !_vm.music.paused
                            ? _c("vs-icon", {
                                staticClass: "control",
                                attrs: { icon: "stop_circle" },
                                on: {
                                  click: function ($event) {
                                    _vm.story && _vm.story.isReel
                                      ? _vm.$store.commit(
                                          "updateStorificationMusicReel",
                                          { paused: true }
                                        )
                                      : _vm.$store.commit(
                                          "updateStorificationMusic",
                                          { paused: true }
                                        )
                                  },
                                },
                              })
                            : _c("vs-icon", {
                                staticClass: "control",
                                attrs: { icon: "play_arrow" },
                                on: {
                                  click: function ($event) {
                                    _vm.story && _vm.story.isReel
                                      ? _vm.$store.commit(
                                          "updateStorificationMusicReel",
                                          { paused: false }
                                        )
                                      : _vm.$store.commit(
                                          "updateStorificationMusic",
                                          { paused: false }
                                        )
                                  },
                                },
                              }),
                          _c(
                            "div",
                            { staticClass: "music-position-container" },
                            [
                              _c("div", {
                                staticClass: "music-position",
                                style: { left: _vm.positionMusicBar },
                              }),
                            ]
                          ),
                          _c("div", { staticClass: "music-progress" }, [
                            _c("div", {
                              ref: "music-percent",
                              staticClass: "music-percent",
                            }),
                          ]),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "music-preview",
                          style:
                            (_vm.story &&
                              _vm.story.isReel &&
                              `bottom: 10px; left: 10px; top: unset;`) ||
                            (_vm.preview && `top: 10px; left: 5px;`),
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "https://media.giphy.com/media/0mKYWcPUzB0Jp4qXsh/giphy.gif",
                            },
                          }),
                          _c("p", [
                            _c("b", [_vm._v(_vm._s(_vm.musicPreview[0]))]),
                            _vm._v(" . " + _vm._s(_vm.musicPreview[1]) + " ›"),
                          ]),
                        ]
                      ),
                ]
              )
            : _vm._e(),
          _vm.poll && !_vm.screenshotPuppeteer
            ? _c(
                "div",
                {
                  staticClass: "poll-container-view",
                  class: `interactable-${_vm._uid} draggable-${_vm._uid} resizable-${_vm._uid}`,
                  style:
                    _vm.currentMod === _vm.Mods.CROPPING && "display: none;",
                  attrs: {
                    "data-name": "Poll",
                    "data-init": _vm.poll && JSON.stringify(_vm.poll),
                  },
                },
                [
                  _vm.pollHasQuestion
                    ? _c("div", { staticClass: "poll-question" }, [
                        _c("p", {}, [
                          _vm._v(_vm._s(_vm.poll.question || "Question ?")),
                        ]),
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "poll-choices",
                      style:
                        !_vm.pollHasQuestion &&
                        "border-top-left-radius: 10px; border-top-right-radius: 10px;",
                    },
                    [
                      _c(
                        "span",
                        {
                          class: `choice-container${
                            !_vm.pollHasQuestion ? " no-question" : ""
                          }`,
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text-choice",
                              attrs: { id: "poll-option-1" },
                            },
                            [_vm._v(_vm._s(_vm.poll.options[0] || "Oui"))]
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          class: `choice-container${
                            !_vm.pollHasQuestion ? " no-question" : ""
                          }`,
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text-choice",
                              attrs: { id: "poll-option-2" },
                            },
                            [_vm._v(_vm._s(_vm.poll.options[1] || "Non"))]
                          ),
                        ]
                      ),
                      _vm.poll.options[2]
                        ? _c(
                            "span",
                            {
                              class: `choice-container${
                                !_vm.pollHasQuestion ? " no-question" : ""
                              }`,
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "text-choice",
                                  attrs: { id: "poll-option-2" },
                                },
                                [_vm._v(_vm._s(_vm.poll.options[2]))]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.poll.options[3]
                        ? _c(
                            "span",
                            {
                              class: `choice-container${
                                !_vm.pollHasQuestion ? " no-question" : ""
                              }`,
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "text-choice",
                                  attrs: { id: "poll-option-2" },
                                },
                                [_vm._v(_vm._s(_vm.poll.options[3]))]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c("div", { staticClass: "corner edge-top edge-left" }),
                  _c("div", { staticClass: "corner edge-top edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-left" }),
                  _c("img", {
                    staticClass: "rotation-icon",
                    class: `rotation-${_vm._uid}`,
                    attrs: {
                      hidden: !!_vm.preview,
                      "data-no-deselect": "",
                      src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm.slider && !_vm.screenshotPuppeteer
            ? _c(
                "div",
                {
                  ref: "slider",
                  staticClass: "slider-container-view",
                  class: `interactable-${_vm._uid} draggable-${_vm._uid} resizable-${_vm._uid} colorable-${_vm._uid} style-color-0`,
                  style:
                    _vm.currentMod === _vm.Mods.CROPPING && "display: none;",
                  attrs: {
                    "data-name": "Slider",
                    "data-number-style-color": "9",
                    "data-init": _vm.slider && JSON.stringify(_vm.slider),
                  },
                },
                [
                  _vm.slider.question
                    ? _c("p", { staticClass: "slider-question" }, [
                        _vm._v(_vm._s(_vm.slider.question || "Question ?")),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "slider-slide" }, [
                    _c("span", { staticClass: "emoji" }, [
                      _vm._v(_vm._s(_vm.slider.emoji)),
                    ]),
                    _c("div", { staticClass: "bar" }),
                  ]),
                  _c("div", { staticClass: "corner edge-top edge-left" }),
                  _c("div", { staticClass: "corner edge-top edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-left" }),
                  _c("img", {
                    staticClass: "rotation-icon",
                    class: `rotation-${_vm._uid}`,
                    attrs: {
                      hidden: !!_vm.preview,
                      "data-no-deselect": "",
                      src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm.question && !_vm.screenshotPuppeteer
            ? _c(
                "div",
                {
                  class: `interactable-${_vm._uid} draggable-${_vm._uid} resizable-${_vm._uid} colorable-${_vm._uid} question-container-view style-color-0`,
                  style:
                    _vm.currentMod === _vm.Mods.CROPPING && "display: none;",
                  attrs: {
                    "data-name": "Question",
                    "data-init": _vm.question && JSON.stringify(_vm.question),
                    "data-number-style-color": "9",
                  },
                },
                [
                  _c("img", {
                    staticClass: "question-avatar",
                    attrs: {
                      src: _vm.question.avatar
                        ? _vm.question.avatar
                        : _vm.informations.pageInfo.avatar ||
                          "https://s3.eu-west-1.amazonaws.com/saas.mashup.sandbox/img/avatar_instagram.png",
                      alt: "Avatar",
                    },
                  }),
                  _c("p", { staticClass: "question-txt" }, [
                    _vm._v(
                      _vm._s(_vm.question.text || "Posez-moi une question")
                    ),
                  ]),
                  _c("p", { staticClass: "question-resp" }, [
                    _vm._v("Entrez quelque chose..."),
                  ]),
                  _c("div", { staticClass: "corner edge-top edge-left" }),
                  _c("div", { staticClass: "corner edge-top edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-left" }),
                  _c("img", {
                    staticClass: "rotation-icon",
                    class: `rotation-${_vm._uid}`,
                    attrs: {
                      hidden: !!_vm.preview,
                      "data-no-deselect": "",
                      src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm.location
            ? _c(
                "div",
                {
                  ref: "location",
                  staticClass: "mentions-container-view",
                  class: `interactable-${_vm._uid} draggable-${_vm._uid} resizable-${_vm._uid} colorable-${_vm._uid} style-color-0`,
                  style:
                    _vm.currentMod === _vm.Mods.CROPPING && "display: none;",
                  attrs: {
                    "data-name": "Location",
                    "data-number-style-color": "4",
                    "data-init": _vm.location && JSON.stringify(_vm.location),
                  },
                },
                [
                  _vm.location.color === 3
                    ? _c("span", { staticClass: "location-widget-text" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              baseProfile: "tiny",
                              height: "24px",
                              id: "Layer_1",
                              version: "1.2",
                              viewBox: "0 0 24 24",
                              width: "24px",
                              "xml:space": "preserve",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            },
                          },
                          [
                            _c(
                              "defs",
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "g1",
                                      x1: "0.14",
                                      y1: "0.15",
                                      x2: "0.86",
                                      y2: "0.85",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      attrs: {
                                        offset: "9%",
                                        "stop-color": "#f6d860",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "18%",
                                        "stop-color": "#ed894b",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "28%",
                                        "stop-color": "#d53a42",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "62%",
                                        "stop-color": "#ea3469",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "77%",
                                        "stop-color": "#ed64a6",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "92%",
                                        "stop-color": "#7638fa",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("path", {
                              attrs: {
                                fill: "url(#g1)",
                                d: "M17.657,5.304c-3.124-3.073-8.189-3.073-11.313,0c-3.124,3.074-3.124,8.057,0,11.13L12,21.999l5.657-5.565  C20.781,13.361,20.781,8.378,17.657,5.304z M12,13.499c-0.668,0-1.295-0.26-1.768-0.732c-0.975-0.975-0.975-2.561,0-3.536  c0.472-0.472,1.1-0.732,1.768-0.732s1.296,0.26,1.768,0.732c0.975,0.975,0.975,2.562,0,3.536C13.296,13.239,12.668,13.499,12,13.499  z",
                              },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "location-name" }, [
                          _vm._v(_vm._s(_vm.location.name)),
                        ]),
                      ])
                    : _vm.location.color === 2
                    ? _c("span", { staticClass: "location-widget-text" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              baseProfile: "tiny",
                              height: "24px",
                              id: "Layer_1",
                              version: "1.2",
                              viewBox: "0 0 24 24",
                              width: "24px",
                              "xml:space": "preserve",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            },
                          },
                          [
                            _c(
                              "defs",
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "g1",
                                      x1: "0.14",
                                      y1: "0.15",
                                      x2: "0.86",
                                      y2: "0.85",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      attrs: {
                                        offset: "9%",
                                        "stop-color": "#f6d860",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "18%",
                                        "stop-color": "#ed894b",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "28%",
                                        "stop-color": "#d53a42",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "62%",
                                        "stop-color": "#ea3469",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "77%",
                                        "stop-color": "#ed64a6",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "92%",
                                        "stop-color": "#7638fa",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("path", {
                              attrs: {
                                fill: "url(#g1)",
                                d: "M17.657,5.304c-3.124-3.073-8.189-3.073-11.313,0c-3.124,3.074-3.124,8.057,0,11.13L12,21.999l5.657-5.565  C20.781,13.361,20.781,8.378,17.657,5.304z M12,13.499c-0.668,0-1.295-0.26-1.768-0.732c-0.975-0.975-0.975-2.561,0-3.536  c0.472-0.472,1.1-0.732,1.768-0.732s1.296,0.26,1.768,0.732c0.975,0.975,0.975,2.562,0,3.536C13.296,13.239,12.668,13.499,12,13.499  z",
                              },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "location-name" }, [
                          _vm._v(_vm._s(_vm.location.name)),
                        ]),
                      ])
                    : _c("span", { staticClass: "location-widget-text" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              baseProfile: "tiny",
                              height: "24px",
                              id: "Layer_1",
                              version: "1.2",
                              viewBox: "0 0 24 24",
                              width: "24px",
                              "xml:space": "preserve",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M17.657,5.304c-3.124-3.073-8.189-3.073-11.313,0c-3.124,3.074-3.124,8.057,0,11.13L12,21.999l5.657-5.565  C20.781,13.361,20.781,8.378,17.657,5.304z M12,13.499c-0.668,0-1.295-0.26-1.768-0.732c-0.975-0.975-0.975-2.561,0-3.536  c0.472-0.472,1.1-0.732,1.768-0.732s1.296,0.26,1.768,0.732c0.975,0.975,0.975,2.562,0,3.536C13.296,13.239,12.668,13.499,12,13.499  z",
                              },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "location-name" }, [
                          _vm._v(_vm._s(_vm.location.name)),
                        ]),
                      ]),
                  _c("div", { staticClass: "corner edge-top edge-left" }),
                  _c("div", { staticClass: "corner edge-top edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-left" }),
                  _c("img", {
                    staticClass: "rotation-icon",
                    class: `rotation-${_vm._uid}`,
                    attrs: {
                      hidden: !!_vm.preview,
                      "data-no-deselect": "",
                      src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm.product &&
          _vm.product.items &&
          _vm.product.items.length &&
          !_vm.screenshotPuppeteer
            ? _c(
                "div",
                {
                  ref: "product",
                  staticClass: "mentions-container-view",
                  class: `interactable-${_vm._uid} draggable-${_vm._uid} resizable-${_vm._uid} colorable-${_vm._uid} style-color-0`,
                  style:
                    _vm.currentMod === _vm.Mods.CROPPING && "display: none;",
                  attrs: {
                    "data-name": "Product",
                    "data-number-style-color": "4",
                    "data-init": _vm.product && JSON.stringify(_vm.product),
                  },
                },
                [
                  _vm.product.color === 2
                    ? _c("span", { staticClass: "product-widget-text" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              viewBox: "0 0 24 24",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24px",
                              height: "24px",
                            },
                          },
                          [
                            _c(
                              "defs",
                              [
                                _c(
                                  "linearGradient",
                                  {
                                    attrs: {
                                      id: "g1",
                                      x1: "0.14",
                                      y1: "0.15",
                                      x2: "0.86",
                                      y2: "0.85",
                                    },
                                  },
                                  [
                                    _c("stop", {
                                      attrs: {
                                        offset: "9%",
                                        "stop-color": "#f6d860",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "18%",
                                        "stop-color": "#ed894b",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "28%",
                                        "stop-color": "#d53a42",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "62%",
                                        "stop-color": "#ea3469",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "77%",
                                        "stop-color": "#ed64a6",
                                      },
                                    }),
                                    _c("stop", {
                                      attrs: {
                                        offset: "92%",
                                        "stop-color": "#7638fa",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("path", {
                              attrs: {
                                fill: "url(#g1)",
                                d: "M -299.7 -54 C -298.6 -53.2 -298 -52.3 -297.8 -51 C -297.8 -51 -297.8 -50.7 -297.8 -50.7 C -297.8 -50.7 -297.8 -50.6 -297.8 -50.6 C -297.8 -50.6 -297.8 -50.6 -297.8 -50.6 C -297.8 -50.6 -297.8 -50.6 -297.8 -50.6 C -297.5 -50.6 -297.1 -50.6 -297 -50.6 C -296.7 -50.6 -296.7 -50.6 -296.5 -50.6 C -295.3 -50.6 -295.3 -50.6 -294.9 -50.4 C -294.9 -50.4 -294.9 -50.4 -294.8 -50.4 C -294.2 -49.9 -293.5 -49.5 -293.3 -48.8 C -293.3 -48.7 -293.3 -48.4 -293.2 -47.9 C -293.2 -47.9 -293.2 -47.9 -293.2 -47.9 C -293.2 -47.7 -293.2 -47.6 -293.2 -47.6 C -293.2 -47.3 -293.2 -47.3 -293.2 -47.3 C -293.2 -46.8 -293.2 -46.6 -293.2 -46.4 C -293.2 -46.2 -293.2 -46 -293.2 -45.7 C -292.9 -45.3 -292.9 -44.9 -292.9 -44.5 C -292.9 -44.1 -292.6 -43.5 -292.6 -42.9 C -292.6 -42.5 -292.6 -41.9 -292.6 -41.6 C -292.6 -41.4 -292.6 -41.2 -292.4 -40.8 C -292.4 -40.7 -292.4 -40.5 -292.4 -40.3 C -292.4 -40.1 -292.4 -40.1 -292.4 -40.1 C -292.4 -40 -292.4 -39.6 -292.4 -39.6 C -292.4 -39.6 -292.4 -39.6 -292.4 -39.6 C -292.2 -38.1 -292.6 -36.7 -293.5 -35.7 C -294.8 -34.6 -295.9 -34 -297.5 -33.6 C -297.8 -33.6 -298 -33.6 -298.6 -33.6 C -298.6 -33.6 -298.7 -33.6 -298.7 -33.6 C -298.9 -33.6 -299.2 -33.6 -299.4 -33.6 C -299.8 -33.6 -300.2 -33.6 -300.3 -33.6 C -300.8 -33.6 -301.3 -33.6 -302 -33.6 C -302.4 -33.6 -302.9 -33.6 -303.5 -33.6 C -304 -33.6 -304.3 -33.6 -304.8 -33.6 C -305.1 -33.6 -305.5 -33.6 -305.8 -33.6 C -305.9 -33.6 -306.2 -33.6 -306.4 -33.6 C -306.4 -33.6 -306.7 -33.6 -306.7 -33.6 C -308.2 -33.6 -309.6 -34 -310.7 -35.1 C -310.7 -35.1 -310.7 -35.1 -310.7 -35.1 C -311.8 -35.9 -312.4 -37.3 -312.8 -38.5 C -312.8 -38.8 -312.8 -39 -312.8 -39.2 C -312.8 -39.2 -312.8 -39.2 -312.8 -39.2 C -312.8 -39.6 -312.4 -40.1 -312.4 -40.5 C -312.4 -40.5 -312.4 -40.7 -312.4 -40.7 C -312.4 -40.8 -312.4 -41.2 -312.4 -41.4 C -312.4 -41.6 -312.4 -41.8 -312.4 -41.8 C -312.3 -42.3 -312.3 -42.7 -312.3 -43.4 C -312.3 -43.8 -312.3 -44.2 -312.1 -44.6 C -312.1 -45 -312.1 -45.6 -312.1 -46 C -312.1 -46.2 -312.1 -46.4 -311.8 -46.6 C -311.8 -46.8 -311.8 -47.2 -311.8 -47.3 C -311.8 -47.6 -311.8 -47.6 -311.8 -47.7 C -311.8 -48.7 -311.6 -49.3 -310.7 -49.9 C -310.2 -50.4 -309.6 -50.6 -308.9 -50.6 C -308.9 -50.6 -308.9 -50.6 -308.9 -50.6 C -308.6 -50.6 -308.5 -50.6 -308.2 -50.6 C -308.2 -50.6 -308.2 -50.6 -307.9 -50.6 C -307.8 -50.6 -307.5 -50.6 -307.4 -50.6 C -307.4 -50.6 -307.4 -50.6 -307.4 -50.6 C -307.4 -51.8 -306.7 -52.8 -305.8 -53.7 C -304.1 -55.1 -301.4 -55.5 -299.7 -54 Z M -304.7 -52.3 C -305.1 -51.7 -305.2 -51.3 -305.2 -50.6 C -303.5 -50.6 -301.6 -50.6 -299.8 -50.6 C -299.8 -51.3 -300.2 -51.8 -300.5 -52.3 C -301 -52.9 -302 -53.2 -302.5 -53.2 C -303.2 -53.2 -304.1 -52.8 -304.7 -52.3 Z M -306.8 -46.6 C -307.4 -46.2 -307 -45.7 -307 -45.3 C -306.8 -44.5 -306.4 -43.8 -305.9 -43.1 C -305.9 -43.1 -305.9 -43.1 -305.9 -43.1 C -305.1 -42.3 -304 -41.8 -302.9 -41.8 C -301.4 -41.6 -300.3 -41.9 -299.2 -42.9 C -298.6 -43.8 -298 -44.9 -297.8 -46 C -297.8 -46.4 -298 -46.6 -298.3 -46.6 C -298.6 -46.8 -298.7 -46.8 -298.9 -46.8 C -299.2 -46.8 -299.4 -46.8 -299.4 -46.6 C -299.7 -46.4 -299.7 -46.2 -299.8 -46 C -299.8 -45 -300.2 -44.5 -300.8 -44.1 C -301.4 -43.5 -302.1 -43.4 -303 -43.5 C -303.7 -43.5 -304.3 -44.1 -304.8 -44.6 C -305.1 -45 -305.2 -45.6 -305.2 -46 C -305.2 -46.4 -305.2 -46.4 -305.8 -46.8 C -305.9 -46.8 -305.9 -47.2 -306.4 -46.8 C -306.7 -46.8 -306.7 -46.8 -306.8 -46.6 Z",
                                transform: "matrix(1,0,0,1,314.1,55.9)",
                              },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "product-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.product.items.length > 1
                                ? `${_vm.product.items.length} ${
                                    _vm.$t("dash.post.text.product") + "s"
                                  }`
                                : _vm.product.items[0].text.length > 30
                                ? _vm.product.items[0].text.slice(0, 30) + "..."
                                : _vm.product.items[0].text
                            )
                          ),
                        ]),
                      ])
                    : _c("span", { staticClass: "product-widget-text" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              viewBox: "0 0 24 24",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24px",
                              height: "24px",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M -299.7 -54 C -298.6 -53.2 -298 -52.3 -297.8 -51 C -297.8 -51 -297.8 -50.7 -297.8 -50.7 C -297.8 -50.7 -297.8 -50.6 -297.8 -50.6 C -297.8 -50.6 -297.8 -50.6 -297.8 -50.6 C -297.8 -50.6 -297.8 -50.6 -297.8 -50.6 C -297.5 -50.6 -297.1 -50.6 -297 -50.6 C -296.7 -50.6 -296.7 -50.6 -296.5 -50.6 C -295.3 -50.6 -295.3 -50.6 -294.9 -50.4 C -294.9 -50.4 -294.9 -50.4 -294.8 -50.4 C -294.2 -49.9 -293.5 -49.5 -293.3 -48.8 C -293.3 -48.7 -293.3 -48.4 -293.2 -47.9 C -293.2 -47.9 -293.2 -47.9 -293.2 -47.9 C -293.2 -47.7 -293.2 -47.6 -293.2 -47.6 C -293.2 -47.3 -293.2 -47.3 -293.2 -47.3 C -293.2 -46.8 -293.2 -46.6 -293.2 -46.4 C -293.2 -46.2 -293.2 -46 -293.2 -45.7 C -292.9 -45.3 -292.9 -44.9 -292.9 -44.5 C -292.9 -44.1 -292.6 -43.5 -292.6 -42.9 C -292.6 -42.5 -292.6 -41.9 -292.6 -41.6 C -292.6 -41.4 -292.6 -41.2 -292.4 -40.8 C -292.4 -40.7 -292.4 -40.5 -292.4 -40.3 C -292.4 -40.1 -292.4 -40.1 -292.4 -40.1 C -292.4 -40 -292.4 -39.6 -292.4 -39.6 C -292.4 -39.6 -292.4 -39.6 -292.4 -39.6 C -292.2 -38.1 -292.6 -36.7 -293.5 -35.7 C -294.8 -34.6 -295.9 -34 -297.5 -33.6 C -297.8 -33.6 -298 -33.6 -298.6 -33.6 C -298.6 -33.6 -298.7 -33.6 -298.7 -33.6 C -298.9 -33.6 -299.2 -33.6 -299.4 -33.6 C -299.8 -33.6 -300.2 -33.6 -300.3 -33.6 C -300.8 -33.6 -301.3 -33.6 -302 -33.6 C -302.4 -33.6 -302.9 -33.6 -303.5 -33.6 C -304 -33.6 -304.3 -33.6 -304.8 -33.6 C -305.1 -33.6 -305.5 -33.6 -305.8 -33.6 C -305.9 -33.6 -306.2 -33.6 -306.4 -33.6 C -306.4 -33.6 -306.7 -33.6 -306.7 -33.6 C -308.2 -33.6 -309.6 -34 -310.7 -35.1 C -310.7 -35.1 -310.7 -35.1 -310.7 -35.1 C -311.8 -35.9 -312.4 -37.3 -312.8 -38.5 C -312.8 -38.8 -312.8 -39 -312.8 -39.2 C -312.8 -39.2 -312.8 -39.2 -312.8 -39.2 C -312.8 -39.6 -312.4 -40.1 -312.4 -40.5 C -312.4 -40.5 -312.4 -40.7 -312.4 -40.7 C -312.4 -40.8 -312.4 -41.2 -312.4 -41.4 C -312.4 -41.6 -312.4 -41.8 -312.4 -41.8 C -312.3 -42.3 -312.3 -42.7 -312.3 -43.4 C -312.3 -43.8 -312.3 -44.2 -312.1 -44.6 C -312.1 -45 -312.1 -45.6 -312.1 -46 C -312.1 -46.2 -312.1 -46.4 -311.8 -46.6 C -311.8 -46.8 -311.8 -47.2 -311.8 -47.3 C -311.8 -47.6 -311.8 -47.6 -311.8 -47.7 C -311.8 -48.7 -311.6 -49.3 -310.7 -49.9 C -310.2 -50.4 -309.6 -50.6 -308.9 -50.6 C -308.9 -50.6 -308.9 -50.6 -308.9 -50.6 C -308.6 -50.6 -308.5 -50.6 -308.2 -50.6 C -308.2 -50.6 -308.2 -50.6 -307.9 -50.6 C -307.8 -50.6 -307.5 -50.6 -307.4 -50.6 C -307.4 -50.6 -307.4 -50.6 -307.4 -50.6 C -307.4 -51.8 -306.7 -52.8 -305.8 -53.7 C -304.1 -55.1 -301.4 -55.5 -299.7 -54 Z M -304.7 -52.3 C -305.1 -51.7 -305.2 -51.3 -305.2 -50.6 C -303.5 -50.6 -301.6 -50.6 -299.8 -50.6 C -299.8 -51.3 -300.2 -51.8 -300.5 -52.3 C -301 -52.9 -302 -53.2 -302.5 -53.2 C -303.2 -53.2 -304.1 -52.8 -304.7 -52.3 Z M -306.8 -46.6 C -307.4 -46.2 -307 -45.7 -307 -45.3 C -306.8 -44.5 -306.4 -43.8 -305.9 -43.1 C -305.9 -43.1 -305.9 -43.1 -305.9 -43.1 C -305.1 -42.3 -304 -41.8 -302.9 -41.8 C -301.4 -41.6 -300.3 -41.9 -299.2 -42.9 C -298.6 -43.8 -298 -44.9 -297.8 -46 C -297.8 -46.4 -298 -46.6 -298.3 -46.6 C -298.6 -46.8 -298.7 -46.8 -298.9 -46.8 C -299.2 -46.8 -299.4 -46.8 -299.4 -46.6 C -299.7 -46.4 -299.7 -46.2 -299.8 -46 C -299.8 -45 -300.2 -44.5 -300.8 -44.1 C -301.4 -43.5 -302.1 -43.4 -303 -43.5 C -303.7 -43.5 -304.3 -44.1 -304.8 -44.6 C -305.1 -45 -305.2 -45.6 -305.2 -46 C -305.2 -46.4 -305.2 -46.4 -305.8 -46.8 C -305.9 -46.8 -305.9 -47.2 -306.4 -46.8 C -306.7 -46.8 -306.7 -46.8 -306.8 -46.6 Z",
                                transform: "matrix(1,0,0,1,314.1,55.9)",
                              },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "product-name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.product.items.length > 1
                                ? `${_vm.product.items.length} ${
                                    _vm.$t("dash.post.text.product") + "s"
                                  }`
                                : _vm.product.items[0].text.length > 30
                                ? _vm.product.items[0].text.slice(0, 30) + "..."
                                : _vm.product.items[0].text
                            )
                          ),
                        ]),
                      ]),
                  _c("div", { staticClass: "corner edge-top edge-left" }),
                  _c("div", { staticClass: "corner edge-top edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-right" }),
                  _c("div", { staticClass: "corner edge-bottom edge-left" }),
                  _c("img", {
                    staticClass: "rotation-icon",
                    class: `rotation-${_vm._uid}`,
                    attrs: {
                      hidden: !!_vm.preview,
                      "data-no-deselect": "",
                      src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm._l(_vm.mentions, function (mention, idx) {
            return _c(
              "div",
              {
                key: mention.pk,
                staticClass: "mentions-container-view",
                class: `interactable-${_vm._uid} draggable-${
                  _vm._uid
                } resizable-${_vm._uid} colorable-${_vm._uid} style-color-0 ${
                  mention.hide ? "hidden-mention" : ""
                }`,
                style: _vm.currentMod === _vm.Mods.CROPPING && "display: none;",
                attrs: {
                  "data-name": "Mention",
                  "data-index": idx,
                  "data-init": mention && JSON.stringify(mention),
                  "data-number-style-color": "4",
                },
              },
              [
                mention.color === 3
                  ? _c("span", { staticClass: "mention-widget-text" }, [
                      _c("span", { staticClass: "arobase" }, [_vm._v("@")]),
                      _vm._v(_vm._s(mention.id)),
                    ])
                  : _c("span", { staticClass: "mention-widget-text" }, [
                      _vm._v("@" + _vm._s(mention.id)),
                    ]),
                _c("div", { staticClass: "corner edge-top edge-left" }),
                _c("div", { staticClass: "corner edge-top edge-right" }),
                _c("div", { staticClass: "corner edge-bottom edge-right" }),
                _c("div", { staticClass: "corner edge-bottom edge-left" }),
                _c("img", {
                  staticClass: "rotation-icon",
                  class: `rotation-${_vm._uid}`,
                  attrs: {
                    hidden: !!_vm.preview,
                    "data-no-deselect": "",
                    src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                  },
                }),
              ]
            )
          }),
          _vm._l(_vm.hashtags, function (hashtag, idx) {
            return _c(
              "div",
              {
                key: hashtag.hashtag,
                staticClass: "mentions-container-view",
                class: `interactable-${_vm._uid} draggable-${
                  _vm._uid
                } resizable-${_vm._uid} colorable-${_vm._uid} style-color-0 ${
                  hashtag.hide ? "hidden-mention" : ""
                }`,
                style: _vm.currentMod === _vm.Mods.CROPPING && "display: none;",
                attrs: {
                  "data-name": "Hashtag",
                  "data-index": idx,
                  "data-init": hashtag && JSON.stringify(hashtag),
                  "data-number-style-color": "4",
                },
              },
              [
                hashtag.color === 3
                  ? _c("span", { staticClass: "mention-widget-text" }, [
                      _c("span", { staticClass: "arobase" }, [_vm._v("#")]),
                      _vm._v(_vm._s(hashtag.hashtag)),
                    ])
                  : _c("span", { staticClass: "mention-widget-text hashtag" }, [
                      _vm._v("#" + _vm._s(hashtag.hashtag)),
                    ]),
                _c("div", { staticClass: "corner edge-top edge-left" }),
                _c("div", { staticClass: "corner edge-top edge-right" }),
                _c("div", { staticClass: "corner edge-bottom edge-right" }),
                _c("div", { staticClass: "corner edge-bottom edge-left" }),
                _c("img", {
                  staticClass: "rotation-icon",
                  class: `rotation-${_vm._uid}`,
                  attrs: {
                    hidden: !!_vm.preview,
                    "data-no-deselect": "",
                    src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                  },
                }),
              ]
            )
          }),
          _vm.template &&
          _vm.template.config &&
          _vm.template.config !== "custom"
            ? _c("img", {
                staticClass: "template-img",
                attrs: {
                  src: `https://s3.eu-west-1.amazonaws.com/saas.mashup.sandbox/img/${_vm.template.config}.png`,
                },
              })
            : _vm._e(),
          _c("img", {
            staticClass: "delete-widget",
            class: `dropzone-${_vm._uid}`,
            attrs: {
              hidden: !_vm.isDragging,
              src: require("../../assets/img/icon_instagram_trash.svg"),
              "data-html2canvas-ignore": "",
            },
          }),
          _vm.pageIsConnectedConciergerie &&
          _vm.informations.highlight &&
          !_vm.preview &&
          _vm.currentMod !== _vm.Mods.CROPPING &&
          _vm.story &&
          !_vm.story.isReel &&
          !_vm.screenshotPuppeteer
            ? _c(
                "div",
                {
                  staticClass: "highlight-container",
                  attrs: { "data-html2canvas-ignore": "" },
                },
                [
                  _vm.highlight.popup
                    ? _c("div", {
                        staticClass: "close-highlight",
                        on: {
                          click: () => {
                            _vm.highlight.popup = false
                            _vm.isValidHightlight &&
                              _vm.$store.commit(
                                "updateStorificationHightlight",
                                _vm.highlight.current === "__new_highlight__"
                                  ? _vm.highlight.create
                                  : _vm.highlight.current
                              )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm.highlight.popup
                    ? _c("p", { staticClass: "p-highlight" }, [
                        _vm._v("Ajouter aux éléments à la une"),
                      ])
                    : _vm._e(),
                  _vm.highlight.popup
                    ? _c(
                        "div",
                        {
                          ref: "loadingHighlight",
                          staticClass: "highlights vs-con-loading__container",
                        },
                        [
                          _c(
                            "label",
                            { staticClass: "highlight" },
                            [
                              _c("vs-radio", {
                                staticClass: "hidden",
                                attrs: { "vs-value": null },
                                model: {
                                  value: _vm.highlight.current,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.highlight, "current", $$v)
                                  },
                                  expression: "highlight.current",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "highlight-img",
                                  style:
                                    _vm.highlight.current === null &&
                                    "border: solid 2.5px white",
                                },
                                [_vm._v("X")]
                              ),
                              _vm._v("\n                Aucun\n            "),
                            ],
                            1
                          ),
                          _vm._l(_vm.highlight.pages, function (h) {
                            return _c(
                              "label",
                              { key: h.id, staticClass: "highlight" },
                              [
                                _c("vs-radio", {
                                  staticClass: "hidden",
                                  attrs: { "vs-value": h.id },
                                  on: {
                                    change: () => {
                                      _vm.highlight.popup = false
                                      _vm.isValidHightlight &&
                                        _vm.$store.commit(
                                          "updateStorificationHightlight",
                                          _vm.highlight.current ===
                                            "__new_highlight__"
                                            ? _vm.highlight.create
                                            : _vm.highlight.current
                                        )
                                    },
                                  },
                                  model: {
                                    value: _vm.highlight.current,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.highlight, "current", $$v)
                                    },
                                    expression: "highlight.current",
                                  },
                                }),
                                _c("img", {
                                  staticClass: "highlight-img",
                                  style:
                                    _vm.highlight.current === h.id &&
                                    "border: solid 2.5px white",
                                  attrs: { src: h.img, alt: "" },
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(h.title) +
                                    "\n            "
                                ),
                              ],
                              1
                            )
                          }),
                          _c(
                            "label",
                            { staticClass: "highlight" },
                            [
                              _c("vs-radio", {
                                staticClass: "hidden",
                                attrs: { "vs-value": "__new_highlight__" },
                                model: {
                                  value: _vm.highlight.current,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.highlight, "current", $$v)
                                  },
                                  expression: "highlight.current",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "highlight-img",
                                  style:
                                    _vm.highlight.current ===
                                      "__new_highlight__" &&
                                    "border: solid 2.5px white",
                                },
                                [_vm._v("+")]
                              ),
                              _c("vs-input", {
                                staticClass: "new-highlight",
                                style:
                                  _vm.highlight.current ===
                                    "__new_highlight__" &&
                                  "border: solid 1px white",
                                attrs: {
                                  size: "small",
                                  danger: !_vm.isValidHightlight,
                                  "danger-text": "Invalide",
                                },
                                model: {
                                  value: _vm.highlight.create,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.highlight, "create", $$v)
                                  },
                                  expression: "highlight.create",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  !_vm.highlight.popup
                    ? _c("img", {
                        staticClass: "highlight-icon icons-white",
                        attrs: { src: _vm.currentHighlightThumbnail, alt: "" },
                        on: { click: _vm.openHighlight },
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "txt-container-remove-img" }, [
      _c("h3", { staticClass: "title-remove-img" }, [
        _vm._v("Abandonner la photo ?"),
      ]),
      _c("div", { staticClass: "txt-remove-img" }, [
        _vm._v(
          " Si vous revenez en arrière maintenant, vous perdrez votre template"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }